// 国内市场（/china）
// 内容框架：顶部三个跳转链接（产业链 / 品牌 TOP30 / 茶饮 TOP10）+ 左中右三栏数据视图
// （产量 / 产区 / 饮品类 + 中国地图 + 最新动态）。数据来自后台 china.json，本模块仅接管页面静态文案。
export default {
  title: '国内市场',
  groups: [
    {
      title: '顶部链接',
      fields: [
        { key: 'linkChain', label: '顶部链接·中国乳制品产业链', type: 'text', default: '中国乳制品产业链' },
        { key: 'linkBrand', label: '顶部链接·乳制品品牌 TOP30', type: 'text', default: '中国市场乳制品品牌 TOP 30' },
        { key: 'linkTea', label: '顶部链接·茶饮品牌 TOP10', type: 'text', default: '中国市场茶饮品牌 TOP 10' },
      ],
    },
    {
      title: '动态与弹窗',
      fields: [
        { key: 'headNews', label: '最新动态标题', type: 'text', default: '最新动态' },
        { key: 'goLabel', label: '卡片跳转标签', type: 'text', default: 'Go' },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'pageBg', label: '页面背景图（覆盖默认背景，留空用系统底图）', type: 'image', default: '' },
      ],
    },
  ],
}
